// extracted by mini-css-extract-plugin
export var equalColumn = "_el-0";